module.exports = __webpack_public_path__ + "media/images/client-29-dcc8bfbc56233250c6c1013a11139943.png";